import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InfiniteScroll from 'redux-infinite-scroll-sf'

import QuestListItem from '../../mini/QuestListItem'
import QuestsSearchResultsCount from '../../mini/QuestsSearchResultsCount'

import { search } from '../../../utils/messages'

export default class PublishedQuests extends Component {
  constructor(props) {
    super(props)
    this.loadMoreQuestsBound = this.loadMoreQuests.bind(this)
    this.onKeyChangeBound = this.onKeyChange.bind(this)
    this.handleSearchClickBound = this.handleSearchClick.bind(this)
    this.onKeyPressBound = this.onKeyPress.bind(this)
    this.state = {
      keywordFilter: ''
    }
  }

  render() {
    const {
      dispatch,
      clearTitleFilter,
      isLoading,
      keywordFilter,
      total,
      stats,
      user
    } = this.props
    let quests = this.props.quests.map((quest, index) => {
      return (
        <QuestListItem
          quest={quest}
          key={index}
          dispatch={dispatch}
          iconHeightWidth={82}
          user={user}
        />
      )
    })

    return (
      <div className="published-quests">
        {stats && stats.published_quests_count > 0 && (
          <div className="search-container">
            <input
              id="myQuestsTitleFilter"
              type="text"
              placeholder="Search your published quests by title"
              onChange={this.onKeyChangeBound}
              defaultValue={keywordFilter}
              onKeyPress={this.onKeyPressBound}
            />
            {Boolean(keywordFilter) && (
              <div className="clear-title-filter" onClick={clearTitleFilter} />
            )}
            <div className="button" onClick={this.handleSearchClickBound}>
              {search}
            </div>
          </div>
        )}

        {!isLoading && keywordFilter.length > 0 && (
          <QuestsSearchResultsCount totalQuests={total} />
        )}

        {quests && quests.length > 0 && (
          <ul>
            <InfiniteScroll
              items={quests}
              loadMore={this.loadMoreQuestsBound}
              loadingMore={isLoading}
              elementIsScrollable={false}
              showLoader={false}
            />
          </ul>
        )}
        {isLoading && quests.length === 0 && <div className="loading" />}
      </div>
    )
  }

  loadMoreQuests() {
    // Only load more quests if the size of the quest list is less than the totalquest count from the search call
    if (this.props.quests.length < this.props.total) {
      this.props.fetchQuests(this.props.page + 1, false)
    }
  }

  onKeyChange(e) {
    this.setState({
      keywordFilter: e.target.value
    })
  }

  onKeyPress(e) {
    this.props.handleKeyPress(e, this.state.keywordFilter)
  }

  handleSearchClick() {
    this.props.handleSearchClick(this.state.keywordFilter)
  }
}

PublishedQuests.propTypes = {
  handleSearchChange: PropTypes.func.isRequired,
  handleSearchClick: PropTypes.func.isRequired,
  quests: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  keywordFilter: PropTypes.string,
  clearTitleFilter: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  page: PropTypes.number,
  total: PropTypes.number,
  fetchQuests: PropTypes.func.isRequired,
  stats: PropTypes.object,
  user: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/myquests/myquests/PublishedQuests.js